import { NgModule } from "@angular/core";
import { ProgressBarComponent } from "./progress-bar";

@NgModule({
    imports: [],
    declarations: [
        ProgressBarComponent
    ],
    exports: [
        ProgressBarComponent
    ]

})
export class ProgressBarModule {

}



// WEBPACK FOOTER //
// ./src/vas/modules-shared/progress-bar/progress-bar.module.ts